<template>
	<modal
		wrapper="full"
		size="full"
		class="template-modal"
		@close="close"
		:hide-footer="true"
		>
		<!-- <template slot="header">
		</template> -->
		<template slot="body">
		<span>
			<div @click="close"  class="modal-close-media-template">
					<i class="material-icons font15">close</i>
			</div>
			<loading :active.sync="isUploading" :background-color="colorOverlay" :color="colorLoading">
				<template slot="after">
					<div class="absolute mt-1 ml-1">{{ $t('Uploading') }}...</div>
				</template>
			</loading>
			<loading :active.sync="isUploadingAssets" :background-color="colorOverlay" :color="colorLoading">
				<template slot="after">
					<div class="absolute mt-1 ml-1">{{ $t('Uploading') }}...</div>
				</template>
			</loading>
			<div>
				<div class="ml-4 lottie-body">
					<div><h2 class="text-primary ml-3 mt-4">{{ $t('Upload Lottie') }}</h2></div>
					<div class="form-group mb-3 mt-2 ml-3">
						<span class="text-grey">
							{{$t('Lottie Template Name')}}
						</span>
						<input
							type="text"
							class="form-control"
							v-model="template.name"
						/>
					</div>
					<!-- File Path -->
					<div class="form-group mb-2 mt-4 d-flex">
						<!-- Upload -->
						<label
							class="btn min-w-100 btn-primary mb-0 ml-3">
							<span class="text-black">{{ $t('Upload Lottie File (.JSON)') }}</span>
							<input
								type="file"
								accept=".json"
								class="hidden"
								id="inputLottieNonAdmin"
								@change="onFileSelected"
							/>
						</label>
						<md-icon v-if="template.file_path" class="icon-4-feedback absolute pt-2 ml-17em">check_circle</md-icon>
					</div>
					<!-- File Path -->
					<div class="form-group mb-2 mt-4 d-flex">
						<!-- Upload -->
						<label
							class="btn btn-primary min-w-100 mb-0 ml-3">
							<div v-if="isUploadingImage" class="spinner-border spinner-border-sm" role="status">
								<span class="sr-only">Loading...</span>
							</div>
							<span v-if="!isUploadingImage" class="text-black">{{ $t('Upload Thumbnail') }}</span>
							<input
								type="file"
								accept=".png,.gif,.jpeg,.jpg"
								class="hidden"
								id="inputTnLottieNonAdmin"
								@change="onImagePreviewSelected"
							/>
						</label>
						<md-icon v-if="template.img_path" class="icon-4-feedback absolute pt-2 ml-17em">check_circle</md-icon>
					</div>
					<!-- Upload Assets -->
					<div class="form-group mb-3 mt-4 d-flex">
						<!-- Upload -->
						<label
							class="btn btn-primary min-w-100 mb-0 ml-3" :class="{'disabled': !template.file_path}">
							<div v-if="isUploadingAssets" class="spinner-border spinner-border-sm" role="status">
								<span class="sr-only">Loading...</span>
							</div>
							<span v-if="!isUploadingAssets" class="text-black" :class="{'text-white': !template.file_path}">{{ $t('Additional Assets') }}</span>
							<input
								type="file"
								accept=".zip"
								class="hidden"
								id="inputAssetLottieNonAdmin"
								@change="onFileAssetSelected"
							/>
						</label>
						<md-icon v-if="template.assets_url" class="icon-4-feedback absolute pt-2 ml-17em">check_circle</md-icon>
					</div>
					<div class="text-grey ml-3">
						{{$t('(Optional) If your template has additional media asset, in zip file, without folder and not password protected')}}
					</div>
					<!-- Add New -->
					<div class="mb-3 min-w-100 pr-3 mt-4 ml-3" v-if="!data || !update">
						<button
							type="submit"
							:disabled="!template.name"
							class="btn min-w-100 btn-primary mt-4 mb-2"
							@click="createTemplate()">
							{{ $t('Create Template') }}
						</button>
					</div>
					<!-- Update -->
					<div class="mb-3 min-w-100 pr-3 mt-4 ml-3" v-if="data && update">
						<button
							type="submit"
							:disabled="!template.name"
							class="btn min-w-100 mr-3 btn-primary mt-4 mb-2"
							@click="updateTemplate()">
							{{ $t('Update Template') }}
						</button>
					</div>
				</div>
			</div>
			<!-- <TemplatePreview ref="templatePreview" :template="activeTemplate" :lottieTemplate="activeLottie" /> -->
		</span>
		</template>
	</modal>
</template>

<script>
import $ from 'jquery';
import { mapGetters } from 'vuex';
import Loading from 'vue-loading-overlay';
import localforage from 'localforage';
import Modal from '@/components/Modal.vue';
import 'vue-loading-overlay/dist/vue-loading.css';
import templatesApi from '@/api/templates';
// import TemplatePreview from '@/components/TemplatePreview.vue';
import categoriesApi from '@/api/categories';
import fileApi from '@/api/file';
import rundownsApi from '@/api/rundowns';

import {
	getAxiosErrorMessage,
	duplicateVar,
	getVideoBlob,
	// delay,
} from '@/lib/helper';

const defaultTemplate = {
	name: '',
	type: '',
	descriptions: '',
	content: '',
	category: '',
	file_path: '',
	img_path: '',
};
export default {
	name: 'UploadLottie',
	props: {
		data: {
			type: Object,
		},
		update: {
			type: Boolean,
		},
	},
	components: {
		// TemplatePreview,
		Loading,
		Modal,
	},
	data() {
		return {
			template: defaultTemplate,
			isLoadingTemplate: false,
			isUploading: false,
			isUploadingImage: false,
			paramsUpdate: '',
			categories: [],
			uploadProgress: 0,
			images: [
				'https://grafias-medias.s3.eu-central-1.amazonaws.com/img/TemplateThumbnailDefault_01.jpg',
				'https://grafias-medias.s3.eu-central-1.amazonaws.com/img/TemplateThumbnailDefault_02.jpg',
				'https://grafias-medias.s3.eu-central-1.amazonaws.com/img/TemplateThumbnailDefault_03.jpg',
				'https://grafias-medias.s3.eu-central-1.amazonaws.com/img/TemplateThumbnailDefault_04.jpg',
			],
			previewTemplate: {},
			isUploadingAssets: false,
			colorOverlay: '#000000',
			colorLoading: '#FFFFFF',
			isUploadAssetVisible: false,
			uploadLimit: '',
			isEnableUploadLimit: false,
			settings: null,
			fileSize: '',
			userClient: {},
		};
	},
	mounted() {
		this.showPreviewCount = 0;
		const templateId = this.data && this.data.id;
		if (templateId && this.update) {
			this.getTemplateById(templateId);
		} else {
			this.template.type = 'lower_third';
			this.template.name = '';
			this.template.description = '';
			this.template.content = '';
			this.template.style = '';
			this.template.duration = '';
			this.template.script = '';
			this.template.img_path = '';
			this.template.file_path = '';
			this.template.category = 4;
		}
		window.addEventListener('resize', this.onResizeWidth);
		this.onResizeWidth();
		window.addEventListener('resize', this.onResizeHeight);
		this.onResizeHeight();
	},
	methods: {
		close() {
			this.$emit('close');
		},
		initDataUser() {
			if (this.user) {
				const settingsString = this.user && this.user.settings ? this.user.settings : '';
				const settings = JSON.parse(settingsString);
				this.settings = settings;
				// const roles = this.user && this.user.roles ? this.user.roles : [];
				const isSuperAdmin = this.isSuperAdmin || null;// check the computed import the getters befor implement
				const isCollaborator = this.isCollaborator || null;// check the computed import the getters befor implement
				const isClient = this.isClient || null;// check the computed import the getters befor implement
				if (!isSuperAdmin && isClient) { // not admin and can be collaborator and client who have two roles
					this.isEnableUploadLimit = settings
					&& settings.subscription
					&& settings.subscription.storage
					&& settings.subscription.storage.is_enabled ? duplicateVar(settings.subscription.storage.is_enabled) : false;
					this.uploadLimit = settings
					&& settings.subscription
					&& settings.subscription.storage
					&& settings.subscription.storage.upload_size ? duplicateVar(settings.subscription.storage.upload_size) : 10;
				} else if ((!isSuperAdmin && isCollaborator && !isClient)) { // only for collaborator that invited by client
					if (this.localClientUser) {
						const userClientSettingsString = this.localClientUser && this.localClientUser.settings ? this.localClientUser.settings : '';
						const userClientSettings = JSON.parse(userClientSettingsString);
						this.isEnableUploadLimit = userClientSettings
						&& userClientSettings.subscription
						&& userClientSettings.subscription.storage
						&& userClientSettings.subscription.storage.is_enabled ? duplicateVar(userClientSettings.subscription.storage.is_enabled) : false;
						this.uploadLimit = userClientSettings
						&& userClientSettings.subscription
						&& userClientSettings.subscription.storage
						&& userClientSettings.subscription.storage.upload_size ? duplicateVar(userClientSettings.subscription.storage.upload_size) : 10;
					}
				} else { // for superadmin only
					this.isEnableUploadLimit = false;
					this.uploadLimit = 1048; // one gb
				}
			}
		},
		onFileSelected(e) {
			this.initDataUser();
			const oneMB = 1048576; // MB
			if (!this.isEnableUploadLimit) {
				this.uploadLimit = 1048; // make it "infinite" when no limiter is set
			}
			let files = e.target.files;
			const fileSizeInMb = files[0].size / oneMB;
			const oneGB = 1048;
			if (files[0].type === 'application/json') {
				if (fileSizeInMb <= oneGB) {
					if (fileSizeInMb <= this.uploadLimit) {
					// check storage
						if (this.rundownStorage && !this.isSuperAdmin) {
							const isRemainingStorageAvailable = this.rundownStorage.total_remaining_size >= 0 && this.rundownStorage.total_remaining_size >= (files[0].size / oneMB);
							const nomalizedTotalRemaining = this.rundownStorage.total_remaining_size <= 0 ? 0 : this.rundownStorage.total_remaining_size;
							if (!isRemainingStorageAvailable) {
								const message = `Your total used Storage is ${this.rundownStorage.total_used_file_size} MB, your currennt remaining size is ${nomalizedTotalRemaining.toFixed(2)}MB`;
								this.$notify({
									group: 'app',
									type: 'warning',
									title: 'Upload Media',
									text: message,
								});
								files = null;
								this.isCached = false;
								this.isCaching = false;
								if (document.querySelector('#inputLottieNonAdmin')) document.querySelector('#inputLottieNonAdmin').value = '';
								return;
							}
							// eslint-disable-next-line no-else-return
						}
						if (files.length > 0) {
							const file = files[0];
							if (!file) {
								this.$notify({
									group: 'app',
									type: 'warn',
									title: 'Upload Media',
									text: 'Sorry, currently we cant upload the file',
								});
								return;
							}

							this.isUploading = true;
							const params = new FormData();
							params.append('file', file);
							// params.append('type', 'lottie');
							const callback = (response) => {
							// const mediaUrl = response.data;
								this.template.file_path = response.data;
								// this.mediaUrl = mediaUrl;
								// this.addMedia();
								this.isUploading = false;
								this.uploadProgress = 0;
							};
							const errorCallback = (e) => {
								const message = getAxiosErrorMessage(e);
								this.$notify({
									group: 'app',
									type: 'error',
									title: 'Upload Media',
									text: message,
								});
								this.isUploading = false;
							};
							const progressCallback = (progress) => {
								this.uploadProgress = progress;
							};
							fileApi.upload(params, callback, errorCallback, progressCallback);
						} else {
							files = null;
							this.isCached = false;
							this.isCaching = false;
							if (document.querySelector('#inputLottieNonAdmin')) document.querySelector('#inputLottieNonAdmin').value = '';
							const appUrl = process.env.VUE_APP_URL;
							this.$notify({
								group: 'app',
								type: 'error',
								text: `You current package upload limit is ${this.uploadLimit} MB, <a href="${appUrl}/settings?menu=subscribe"> Upgrade your subscription </a>`,
							});
						}
					}
				} else {
					files = null;
					this.isCached = false;
					this.isCaching = false;
					if (document.querySelector('#inputLottieNonAdmin')) document.querySelector('#inputLottieNonAdmin').value = '';
					this.$notify({
						group: 'app',
						type: 'error',
						text: 'Max upload limit is 1GB',
					});
				}
			} else {
				this.$notify({
					group: 'app',
					type: 'warning',
					title: 'Upload Media',
					text: 'Unsupported file',
				});
				// eslint-disable-next-line
				return;
			}
		},
		onImagePreviewSelected(e) {
			this.initDataUser();
			// get data max upload
			const oneMB = 1048576; // MB
			if (!this.isEnableUploadLimit) {
				this.uploadLimit = 1048;
			}
			let files = e.target.files;
			const fileSizeInMb = files[0].size / oneMB;
			const oneGB = 1048;
			if (files.length > 0) {
				if (files[0].type === 'image/jpeg' || files[0].type === 'image/gif' || files[0].type === 'image/png' || files[0].type === 'image/jpg') {
					if (fileSizeInMb <= oneGB) {
						if (fileSizeInMb <= this.uploadLimit) {
							if (this.rundownStorage && !this.isSuperAdmin) {
								const isRemainingStorageAvailable = this.rundownStorage.total_remaining_size >= 0 && this.rundownStorage.total_remaining_size >= (files[0].size / oneMB);
								const nomalizedTotalRemaining = this.rundownStorage.total_remaining_size <= 0 ? 0 : this.rundownStorage.total_remaining_size;
								if (!isRemainingStorageAvailable) {
									const message = `Your total used Storage is ${this.rundownStorage.total_used_file_size} MB, your currennt remaining size is ${nomalizedTotalRemaining.toFixed(2)}MB`;
									this.$notify({
										group: 'app',
										type: 'warning',
										title: 'Upload Media',
										text: message,
									});
									files = null;
									return;
								}
							// eslint-disable-next-line no-else-return
							}
							const file = files[0];
							if (!file) {
								this.$notify({
									group: 'app',
									type: 'warn',
									title: 'Upload Media',
									text: 'Sorry, currently we cant upload the file',
								});
								return;
							}
							this.isUploadingImage = true;
							const params = new FormData();
							params.append('file', file);
							// params.append('type', 'lottie');
							const callback = (response) => {
							// const mediaUrl = response.data;
								this.template.img_path = response.data;
								// this.mediaUrl = mediaUrl;
								// this.addMedia();
								this.isUploadingImage = false;
								this.uploadProgress = 0;
								if (document.querySelector('#inputAssetLottieNonAdmin')) document.querySelector('#inputAssetLottieNonAdmin').value = '';
							};
							const errorCallback = (e) => {
								const message = getAxiosErrorMessage(e);
								this.$notify({
									group: 'app',
									type: 'error',
									title: 'Upload Media',
									text: message,
								});
								this.isUploadingImage = false;
							};
							const progressCallback = (progress) => {
								this.uploadProgress = progress;
							};
							fileApi.upload(params, callback, errorCallback, progressCallback);
						} else {
							files = null;
							this.isCached = false;
							this.isCaching = false;
							if (document.querySelector('#inputAssetLottieNonAdmin')) document.querySelector('#inputAssetLottieNonAdmin').value = '';
							const appUrl = process.env.VUE_APP_URL;
							this.$notify({
								group: 'app',
								type: 'error',
								text: `You current package upload limit is ${this.uploadLimit} MB, <a href="${appUrl}/settings?menu=subscribe"> Upgrade your subscription </a>`,
							});
						}
					} else {
						files = null;
						this.isCached = false;
						this.isCaching = false;
						if (document.querySelector('#inputAssetLottieNonAdmin')) document.querySelector('#inputAssetLottieNonAdmin').value = '';
						this.$notify({
							group: 'app',
							type: 'error',
							text: 'Max upload limit is 1GB',
						});
					}
				} else {
					this.$notify({
						group: 'app',
						type: 'warning',
						title: 'Upload Media',
						text: 'Unsupported file',
					});
					// eslint-disable-next-line
					return;
				}
			}
		},
		onFileAssetSelected(e) {
			this.initDataUser();
			// get data max upload
			const oneMB = 1048576; // MB
			if (!this.isEnableUploadLimit) {
				this.uploadLimit = 1048;
			}
			let files = e.target.files;
			const fileSizeInMb = files[0].size / oneMB;
			const oneGB = 1048;
			if (files.length > 0) {
				if (files[0].type === 'application/x-zip-compressed' || files[0].type === 'application/zip') {
					if (fileSizeInMb <= oneGB) {
						if (fileSizeInMb <= this.uploadLimit) {
							if (this.rundownStorage && !this.isSuperAdmin) {
								const isRemainingStorageAvailable = this.rundownStorage.total_remaining_size >= 0 && this.rundownStorage.total_remaining_size >= (files[0].size / oneMB);
								const nomalizedTotalRemaining = this.rundownStorage.total_remaining_size <= 0 ? 0 : this.rundownStorage.total_remaining_size;
								if (!isRemainingStorageAvailable) {
									const message = `Your total used Storage is ${this.rundownStorage.total_used_file_size} MB, your currennt remaining size is ${nomalizedTotalRemaining.toFixed(2)}MB`;
									this.$notify({
										group: 'app',
										type: 'warning',
										title: 'Upload Media',
										text: message,
									});
									files = null;
									return;
								}
							// eslint-disable-next-line no-else-return
							}
							const file = files[0];
							if (!file) {
								this.$notify({
									group: 'app',
									type: 'warn',
									title: 'Upload Media',
									text: 'Sorry, currently we cant upload the file',
								});
								return;
							}

							this.isUploadingAssets = true;
							const params = new FormData();
							params.append('file', file);
							// params.append('type', 'lottie');
							const callback = (response) => {
							// const mediaUrl = response.data;
								this.template.assets_url = response.data;
								// this.mediaUrl = mediaUrl;
								// this.addMedia();
								this.isUploadingAssets = false;
								this.uploadProgress = 0;
								this.isUploadAssetVisible = false;
								if (document.querySelector('#inputAssetLottieNonAdmin')) document.querySelector('#inputAssetLottieNonAdmin').value = '';
							};
							const errorCallback = (e) => {
								const message = getAxiosErrorMessage(e);
								this.$notify({
									group: 'app',
									type: 'error',
									title: 'Upload Media',
									text: message,
								});
								this.isUploadingAssets = false;
							};
							const progressCallback = (progress) => {
								this.uploadProgress = progress;
							};
							fileApi.upload(params, callback, errorCallback, progressCallback);
						} else {
							files = null;
							this.isCached = false;
							this.isCaching = false;
							if (document.querySelector('#inputAssetLottieNonAdmin')) document.querySelector('#inputAssetLottieNonAdmin').value = '';
							const appUrl = process.env.VUE_APP_URL;
							this.$notify({
								group: 'app',
								type: 'error',
								text: `You current package upload limit is ${this.uploadLimit} MB, <a href="${appUrl}/settings?menu=subscribe"> Upgrade your subscription </a>`,
							});
						}
					} else {
						files = null;
						this.isCached = false;
						this.isCaching = false;
						if (document.querySelector('#inputAssetLottieNonAdmin')) document.querySelector('#inputAssetLottieNonAdmin').value = '';
						this.$notify({
							group: 'app',
							type: 'error',
							text: 'Max upload limit is 1GB',
						});
					}
				} else {
					this.$notify({
						group: 'app',
						type: 'warning',
						title: 'Upload Media',
						text: 'Unsupported file',
					});
					// eslint-disable-next-line
					return;
				}
			}
		},
		createTemplate() {
			this.isSaving = true;
			const callback = (response) => {
				const item = response.data;
				const message = response.message;
				this.$emit('saved', item);
				if (!this.data && !this.update) {
					this.template.name = '';
					this.template.img_path = '';
					this.template.file_path = '';
					this.template.assets_url = '';
				}
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Lottie',
					text: message,
					duration: 999999999,
				});
				this.isSaving = false;
				if (!this.data && !this.update) this.close();
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Lottie',
					text: message,
				});
				this.isSaving = false;
			};
			if (this.data && this.update) {
				this.beforeParamsUpdate();
				templatesApi.update(this.template.id, this.paramsUpdate, callback, errorCallback);
			} else {
				templatesApi.create(this.templateParams, callback, errorCallback);
			}
		},
		updateTemplate() {
			this.isSaving = true;
			const callback = (response) => {
				const item = response.data;
				this.$emit('saved', item);
				const message = response.message;
				if (!this.data && !this.update) {
					this.template.name = '';
					this.template.img_path = '';
					this.template.file_path = '';
					this.template.assets_url = '';
				}
				// recahce
				if (this.template.img_path) {
					const itemKey = `thumbnail_${this.template.id}`;
					// eslint-disable-next-line
					localforage.getItem(itemKey, (err, value) => {
						const itemMediaThumbnail = this.template.img_path;
						const itemMediaName = response && response.data.name ? response.data.name : 'template';
						if (itemMediaThumbnail) {
							try {
								getVideoBlob(itemMediaThumbnail).then((blob) => {
									// Set key and blob
									localforage.setItem(itemKey, blob, (err, value) => {
										if (!err && value) {
											// handle success cache here
										}
										if (err) {
											this.$notify({
												duration: 6000,
												closeOnClick: true,
												group: 'app',
												type: 'error',
												title: 'Error loading media',
												text: 'Something went wrong please contact admin!',
											});
										}
									});
								}).catch(() => {
									// error handling logic
									const message = `Template: ${itemMediaName}. Sorry, some media file can't be loaded or media not found, please check`;
									this.$notify({
										duration: 6000,
										closeOnClick: true,
										group: 'app',
										type: 'error',
										title: 'Error loading Template',
										text: message,
									});
								});
							} catch (e) {
							// catch some error here
							}
						}
					});
				}
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Lottie',
					text: message,
					duration: 999999999,
				});
				this.isSaving = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Lottie',
					text: message,
				});
				this.isSaving = false;
			};
			this.beforeParamsUpdate();
			templatesApi.update(this.template.id, this.paramsUpdate, callback, errorCallback);
		},
		getTemplateById(templateId) {
			this.isLoadingTemplate = true;
			const callback = (response) => {
				this.template.id = response.data.id;
				this.template.type = response.data.type;
				this.template.name = response.data.name;
				this.template.description = response.data.description;
				this.template.content = JSON.parse(response.data.content).content;
				this.template.style = JSON.parse(response.data.content).style;
				this.template.script = JSON.parse(response.data.content).script;
				this.template.file_path = response.data.file_path;
				this.template.img_path = response.data.img_path;
				this.template.assets_url = response.data.assets_url;
				this.template.category = response.data.category_id;
				this.isLoadingTemplate = false;
			};
			const templateErrorCallback = (e) => {
				// eslint-disable-next-line
				const response = e.response ? e.response.data : false;
				const message = response ? response.message : '';
				this.$notify({
					group: 'Notification',
					type: 'error',
					title: this.$t('Error'),
					text: message,
				});
				this.isLoadingTemplate = false;
			};
			templatesApi.get(templateId, callback, templateErrorCallback);
		},
		beforeParamsUpdate() {
			const content = {
				content: this.template.content,
				style: this.template.style,
				script: this.template.script,
			};
			this.previewTemplate = content;
			const contentString = JSON.stringify(content);
			const params = {
				name: this.template.name,
				type: this.template.type,
				file_path: this.template.file_path,
				img_path: this.template.img_path,
				assets_url: this.template.assets_url,
				content: contentString,
				status: 1,
				description: this.template.description,
				category_id: this.template.category,
			};
			if (this.template.img_path) {
				params.img_path = this.template.img_path;
			} else {
				params.img_path = this.randomImage(this.images);
			}
			if (this.template.file_path) {
				params.file_path = this.template.file_path;
			}
			if (this.template.assets_url) {
				params.assets_url = this.template.assets_url;
			}
			this.paramsUpdate = params;
		},
		onResizeWidth() {
			if (window.innerWidth <= 2200 && window.innerWidth > 1920) {
				$(document).find('.main-split').css('height', '1000px');
			} else if (window.innerWidth > 2000) {
				$(document).find('.main-split').css('height', '1795px');
			} else if (window.innerWidth <= 1920 && window.innerWidth > 1000) {
				$(document).find('.main-split').css('height', '900px');
			}
		},
		onResizeHeight() {
			if (window.innerHeight <= 1200 && window.innerHeight > 1000) {
				$(document).find('.main-split').css('height', '1595px');
			} else if (window.innerHeight > 1200) {
				$(document).find('.main-split').css('height', '1795px');
			} else if (window.innerHeight > 1700) {
				$(document).find('.main-split').css('height', '1995px');
			}
		},
		fetchCategories() {
			const params = {
				page: 1,
				limit: 1000,
				order_by: 'name',
				sort_by: 'asc',
				type: 'template',
			};
			const callback = (response) => {
				const categories = response.data.data;
				this.categories = categories;
			};
			const errorCallback = () => {};
			categoriesApi.getList(params, callback, errorCallback);
		},
		randomImage(items) {
			return items[Math.floor(Math.random() * items.length)];
		},
		fetchRundown() {
			this.isFetching = true;
			const callback = (response) => {
				const item = response.data;
				this.rundown = item;
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: this.$t(this.title),
					text: message,
				});
				this.isFetching = false;
			};
			rundownsApi.getBySlug(atob(this.activeRouteSlug), callback, errorCallback);
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			clientUser: 'clientUser',
			isClient: 'isClient',
			isSuperAdmin: 'isSuperAdmin',
			isCollaborator: 'isCollaborator',
		}),
		templateParams() {
			const content = {
				content: this.template.content,
				style: this.template.style,
				script: this.template.script,
			};
			const contentString = JSON.stringify(content);
			const params = {
				name: this.template.name,
				type: 'lower_third',
				content: contentString,
				category_id: this.template.category,
				status: 1,
				description: this.template.description,
			};
			if (this.template.img_path) {
				params.img_path = this.template.img_path;
			} else {
				params.img_path = this.randomImage(this.images);
			}
			if (this.template.file_path) {
				params.file_path = this.template.file_path;
			}
			if (this.template.assets_url) {
				params.assets_url = this.template.assets_url;
			}
			return params;
		},
		activeTemplate() {
			return this.previewTemplate;
		},
		activeLottie() {
			const filePath = this.template && this.template.file_path ? this.template.file_path : '';
			return filePath;
		},
		checkEdit() {
			return this.$route.params.template;
		},
		activeRouteSlug() {
			return this.$route.params.slug;
		},
		rundownStorage() {
			return {
				total_max_file_size: this.rundown && this.rundown.total_max_file_size ? this.rundown.total_max_file_size : 0,
				total_remaining_size: this.rundown && this.rundown.total_remaining_size ? this.rundown.total_remaining_size : 0,
				total_used_file_size: this.rundown && this.rundown.total_used_file_size ? this.rundown.total_used_file_size : 0,
			};
		},
	},
	created() {
		this.fetchRundown();
		this.fetchCategories();
		if (this.clientUser) {
			this.localClientUser = this.clientUser;
		}
	},
	watch: {
	},
};
</script>

<style>
</style>
